module.exports = __webpack_public_path__ + "static/media/np.a754e9e8.svg";